import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./HomePage/Home";
import About from "./About/About";
import NavBar from "./NavBar/NavBar";
import Services from "./Services/Services";
import Contact from "./Contact/Contact";
import Feedback from "./Feedback/Feedback";
import "./App.css";

const App = () => {
  return (
    <div className="app-layout">
      <NavBar />
      <main className="page-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
    </div>
  );
};

export default App;
